module.exports = __webpack_public_path__ + "img/everydayink-desktop.41447a4d.jpg";